<template>
  <div class="contentView">
    <div class="navbar">
      <navbar></navbar>
    </div>
    <div class="cnt">
      <!-- <Backgroundimage></Backgroundimage> -->
    </div>

    <!-- 画布区域 -->
    <draggable
      v-model="contentlist"
      group="itxst"
      ghostClass="ghost"
      chosenClass="chosen"
      selector="selector"
      :animation="500"
      :sort="true"
      class="contentViewdraggable"
       :style="[{ background }]"
    >
      <div
        @click.stop="onChooseArea(item)"
        :class="
          item.fieldId == selectedId
            ? 'componentborderactive componentborder'
            : 'componentborder'
        "
        v-for="(item, index) in contentlist"
        :key="item.fieldId"
        
      >
        <component
          :is="item.name"
          v-bind="item"
          :quality="item.configuration.quality"
        ></component>
        <div
          class="componentbtn"
          v-if="item.fieldId == selectedId"
          @click.stop="deleteclcik(item, index)"
        >
          删除

          <i class="el-icon-circle-close"></i>
        </div>
      </div>
    </draggable>
  </div>
</template>

<script>
import Sortable from "sortablejs";
import draggable from "vuedraggable";
import template1 from "@/components/renovation/template1.vue";
import template2 from "@/components/renovation/template2.vue";
import navbar from "@/components/renovation/navbar.vue";
import Backgroundimage from "@/components/renovation/Backgroundimage.vue";
export default {
  name: "contentView",
  components: {
    draggable,
    template1,
    template2,
    navbar,
    Backgroundimage,
  },
  props: {
    receivedList: {
      type: Array,
      default: [],
    },
    obj_item: {
      type: Object,
      default: {

      },
    },
  },
  data() {
    return {
      contentlist: [],
      selectedId: null,

      quality: {},
      background:'#fff',
      url:''
    };
  },

  computed: {
    foundationitem() {
      return this.$store.state.foundation;
    },
    sortcontent() {
      return this.contentlist;
    },
    qualityitem() {
      return this.$store.state.quality;
    },
  },
  watch: {
    receivedList(newV, oldV) {
      this.contentlist = newV;
    },
    obj_item(newV, oldV) {
      this.background=newV.global_color?newV.global_color:'#fff';
      console.log(newV, "全局参数变化global_color");
      this.$store.commit("foundation", {
        main_image:newV.main_image,
        bg_url: newV.bg_url, //顶部背景图片
        global_color: newV.global_color, //
        name: newV.name, //
        
      });
    },
    foundationitem(newV, oldV) {
      this.background = newV.global_color?newV.global_color:'#fff';
     
    },
    sortcontent(newV, oldV) {
      console.log(newV, "新的数据过来了");
      this.$store.commit("addcontentlist", newV);
    },
    qualityitem(newV, oldV) {
      console.log(newV, "属性参数变化中间页面");
      this.quality = newV;
      this.setInof();
    },
  },
  created() {
    this.contentlist = this.receivedList;
  },
  mounted() {},
  methods: {
    setInof() {
      this.contentlist.forEach((el) => {
        if (el.fieldId == this.selectedId) {
          el.configuration.quality = this.quality;
        }
      });
      // console.log(this.contentlist,'属性数据变化中间组件变化内容')
      this.$store.commit("addcontentlist", this.contentlist);
    },
    onChooseArea(e) {
      // console.log(e, "点击了那一条数据",this.contentlist);
      this.selectedId = e.fieldId;
      this.$store.commit("addrenovationitem", e);
      this.$store.commit("addquality", e.configuration.quality);
      // console.log(this.contentlist,'点击了之后数据怎么变化的')
    },
    deleteclcik(e, i) {
      this.contentlist.splice(i, 1);
      this.$store.commit("addcontentlist", this.contentlist);
    },
  },
};
</script>

<style  lang="scss">
.contentView {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  padding-top: 0;
  margin-top: 20px;
  box-sizing: border-box;
  position: relative;
  overflow-y: auto;
  .cnt {
    padding-top: 80px;
    width: 450px;
  }
  .navbar {
    position: fixed;
    width: 450px;
    z-index: 2;
  }
  .contentViewdraggable {
   flex: 1;
    width: 450px;
    // background-color: #fff;
    .componentborder {
      border: 1px dashed #000;
      position: relative;
      margin: 2px 0;
      .componentbtn {
        position: absolute;
        top: 0;
        right: -70px;
        width: 69px;
height: 33px;
border-radius: 0px 16px 16px 0px;
        background: $theme-color;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 400;
font-size: 12px;
color: #FFFFFF;
      }
    }
    .componentborderactive {
      border: 1px solid $theme-color;
    }
  }
}
</style>
